'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('brokerSettingsService', brokerSettingsService);

	brokerSettingsService.$inject = ['$http', '$stateParams', 'sessionService'];

	function brokerSettingsService($http, $stateParams, sessionService) {

		var SEGMENT_TYPES = {
			'image': 'Image',
			'insuranceMessage': 'InsuranceMessage',
			'welcomeMessage': 'WelcomeMessage',
			'contractMessage': 'ContractMessage',
			'documentsMessage': 'DocumentsMessage',
			'signedMessage': 'SignedMessage', 
		};

		return {
			getBrokerSettings: getBrokerSettings,
			setBrokerNotificationSettings: setBrokerNotificationSettings,
			updateBrokerPassword: updateBrokerPassword,
			updateLogo: updateLogo,
			updateMessage: updateMessage
		};


		function getBrokerSettings() {
			var broker = sessionService.getBrokerImpersonated();
			var brokderDomain = broker.domain === undefined ? '' : broker.domain;


			return $http.get('/api/brokersettings/brokersettings', { params: { domain: brokderDomain } });
		}

		function setBrokerNotificationSettings(request) {
			request = brokerImpersonationHelper(request);

			return $http.post('/api/brokersettings/notificationsettings', request);
		}

		function updateBrokerPassword(request) {
			request = brokerImpersonationHelper(request);

			return $http.put('/api/brokerlookup/updateBrokerPassword', request);
		}

		function updateLogo(imageFile, imageMimeType, fileName, fileExtension) {
			var request = {
				segmentType: SEGMENT_TYPES.image,
				segmentData: imageFile,
				mimeType: imageMimeType,
				fileName: fileName,
				fileExtension: fileExtension
			};
			request = brokerImpersonationHelper(request);

			return $http.put('/api/brokersettings/brokerhomepagesegment', request);
		}

		function updateMessage(segmentType, message, disabled) {
			var request = {
				segmentType: SEGMENT_TYPES[segmentType],
				segmentData: message,
				mimeType: 'text/html',
				disabled: disabled
			};
			request = brokerImpersonationHelper(request);

			return $http.put('/api/brokersettings/brokerhomepagesegment', request);
		}

		function brokerImpersonationHelper(request) {
			if ($stateParams.brokerId) {
				if (!request) {
					request = {};
				}
				request.brokerId = $stateParams.brokerId;
			}

			return request;
		}
	}
})();
